module.exports = __webpack_public_path__ + "static/fun-time/games/page010_game0/audio//9_red.mp3";